// This file is automatically generated by scripts/refresh-assets.ts.
// Do not edit manually.

/** @public */
export type TLUiTranslationKey =
	| 'action.convert-to-bookmark'
	| 'action.convert-to-embed'
	| 'action.open-embed-link'
	| 'action.align-bottom'
	| 'action.align-center-horizontal'
	| 'action.align-center-vertical'
	| 'action.align-center-horizontal.short'
	| 'action.align-center-vertical.short'
	| 'action.align-left'
	| 'action.align-right'
	| 'action.align-top'
	| 'action.back-to-content'
	| 'action.bring-forward'
	| 'action.bring-to-front'
	| 'action.copy-as-json.short'
	| 'action.copy-as-json'
	| 'action.copy-as-png.short'
	| 'action.copy-as-png'
	| 'action.copy-as-svg.short'
	| 'action.copy-as-svg'
	| 'action.copy'
	| 'action.cut'
	| 'action.delete'
	| 'action.unlock-all'
	| 'action.distribute-horizontal'
	| 'action.distribute-vertical'
	| 'action.distribute-horizontal.short'
	| 'action.distribute-vertical.short'
	| 'action.duplicate'
	| 'action.edit-link'
	| 'action.exit-pen-mode'
	| 'action.export-as-json.short'
	| 'action.export-as-json'
	| 'action.export-as-png.short'
	| 'action.export-as-png'
	| 'action.export-as-svg.short'
	| 'action.export-as-svg'
	| 'action.flip-horizontal'
	| 'action.flip-vertical'
	| 'action.flip-horizontal.short'
	| 'action.flip-vertical.short'
	| 'action.fork-project'
	| 'action.group'
	| 'action.insert-embed'
	| 'action.insert-media'
	| 'action.leave-shared-project'
	| 'action.new-project'
	| 'action.new-shared-project'
	| 'action.open-cursor-chat'
	| 'action.open-file'
	| 'action.pack'
	| 'action.paste'
	| 'action.print'
	| 'action.redo'
	| 'action.rotate-ccw'
	| 'action.rotate-cw'
	| 'action.save-copy'
	| 'action.select-all'
	| 'action.select-none'
	| 'action.send-backward'
	| 'action.send-to-back'
	| 'action.share-project'
	| 'action.stack-horizontal'
	| 'action.stack-vertical'
	| 'action.stack-horizontal.short'
	| 'action.stack-vertical.short'
	| 'action.stop-following'
	| 'action.stretch-horizontal'
	| 'action.stretch-vertical'
	| 'action.stretch-horizontal.short'
	| 'action.stretch-vertical.short'
	| 'action.toggle-auto-size'
	| 'action.toggle-dark-mode.menu'
	| 'action.toggle-dark-mode'
	| 'action.toggle-reduce-motion.menu'
	| 'action.toggle-reduce-motion'
	| 'action.toggle-debug-mode.menu'
	| 'action.toggle-debug-mode'
	| 'action.toggle-focus-mode.menu'
	| 'action.toggle-focus-mode'
	| 'action.toggle-grid.menu'
	| 'action.toggle-grid'
	| 'action.toggle-lock'
	| 'action.toggle-snap-mode.menu'
	| 'action.toggle-snap-mode'
	| 'action.toggle-tool-lock.menu'
	| 'action.toggle-tool-lock'
	| 'action.toggle-transparent.context-menu'
	| 'action.toggle-transparent.menu'
	| 'action.toggle-transparent'
	| 'action.undo'
	| 'action.ungroup'
	| 'action.zoom-in'
	| 'action.zoom-out'
	| 'action.zoom-to-100'
	| 'action.zoom-to-fit'
	| 'action.zoom-to-selection'
	| 'color-style.black'
	| 'color-style.blue'
	| 'color-style.green'
	| 'color-style.grey'
	| 'color-style.light-blue'
	| 'color-style.light-green'
	| 'color-style.light-red'
	| 'color-style.light-violet'
	| 'color-style.orange'
	| 'color-style.red'
	| 'color-style.violet'
	| 'color-style.yellow'
	| 'fill-style.none'
	| 'fill-style.semi'
	| 'fill-style.solid'
	| 'fill-style.pattern'
	| 'dash-style.dashed'
	| 'dash-style.dotted'
	| 'dash-style.draw'
	| 'dash-style.solid'
	| 'size-style.s'
	| 'size-style.m'
	| 'size-style.l'
	| 'size-style.xl'
	| 'opacity-style.0.1'
	| 'opacity-style.0.25'
	| 'opacity-style.0.5'
	| 'opacity-style.0.75'
	| 'opacity-style.1'
	| 'font-style.draw'
	| 'font-style.sans'
	| 'font-style.serif'
	| 'font-style.mono'
	| 'align-style.start'
	| 'align-style.middle'
	| 'align-style.end'
	| 'align-style.justify'
	| 'geo-style.arrow-down'
	| 'geo-style.arrow-left'
	| 'geo-style.arrow-right'
	| 'geo-style.arrow-up'
	| 'geo-style.diamond'
	| 'geo-style.ellipse'
	| 'geo-style.hexagon'
	| 'geo-style.octagon'
	| 'geo-style.oval'
	| 'geo-style.cloud'
	| 'geo-style.pentagon'
	| 'geo-style.rectangle'
	| 'geo-style.rhombus-2'
	| 'geo-style.rhombus'
	| 'geo-style.star'
	| 'geo-style.trapezoid'
	| 'geo-style.triangle'
	| 'geo-style.x-box'
	| 'geo-style.check-box'
	| 'arrowheadStart-style.none'
	| 'arrowheadStart-style.arrow'
	| 'arrowheadStart-style.bar'
	| 'arrowheadStart-style.diamond'
	| 'arrowheadStart-style.dot'
	| 'arrowheadStart-style.inverted'
	| 'arrowheadStart-style.pipe'
	| 'arrowheadStart-style.square'
	| 'arrowheadStart-style.triangle'
	| 'arrowheadEnd-style.none'
	| 'arrowheadEnd-style.arrow'
	| 'arrowheadEnd-style.bar'
	| 'arrowheadEnd-style.diamond'
	| 'arrowheadEnd-style.dot'
	| 'arrowheadEnd-style.inverted'
	| 'arrowheadEnd-style.pipe'
	| 'arrowheadEnd-style.square'
	| 'arrowheadEnd-style.triangle'
	| 'spline-style.line'
	| 'spline-style.cubic'
	| 'tool.select'
	| 'tool.hand'
	| 'tool.draw'
	| 'tool.eraser'
	| 'tool.arrow-down'
	| 'tool.arrow-left'
	| 'tool.arrow-right'
	| 'tool.arrow-up'
	| 'tool.arrow'
	| 'tool.cloud'
	| 'tool.diamond'
	| 'tool.ellipse'
	| 'tool.hexagon'
	| 'tool.highlight'
	| 'tool.line'
	| 'tool.octagon'
	| 'tool.oval'
	| 'tool.pentagon'
	| 'tool.rectangle'
	| 'tool.rhombus'
	| 'tool.star'
	| 'tool.trapezoid'
	| 'tool.triangle'
	| 'tool.x-box'
	| 'tool.check-box'
	| 'tool.asset'
	| 'tool.frame'
	| 'tool.note'
	| 'tool.laser'
	| 'tool.embed'
	| 'tool.text'
	| 'menu.title'
	| 'menu.copy-as'
	| 'menu.edit'
	| 'menu.export-as'
	| 'menu.file'
	| 'menu.language'
	| 'menu.preferences'
	| 'menu.view'
	| 'context-menu.arrange'
	| 'context-menu.copy-as'
	| 'context-menu.export-as'
	| 'context-menu.move-to-page'
	| 'context-menu.reorder'
	| 'page-menu.title'
	| 'page-menu.create-new-page'
	| 'page-menu.max-page-count-reached'
	| 'page-menu.new-page-initial-name'
	| 'page-menu.edit-start'
	| 'page-menu.edit-done'
	| 'page-menu.go-to-page'
	| 'page-menu.submenu.rename'
	| 'page-menu.submenu.duplicate-page'
	| 'page-menu.submenu.title'
	| 'page-menu.submenu.move-down'
	| 'page-menu.submenu.move-up'
	| 'page-menu.submenu.delete'
	| 'share-menu.title'
	| 'share-menu.save-note'
	| 'share-menu.fork-note'
	| 'share-menu.share-project'
	| 'share-menu.default-project-name'
	| 'share-menu.copy-link'
	| 'share-menu.readonly-link'
	| 'share-menu.create-snapshot-link'
	| 'share-menu.snapshot-link-note'
	| 'share-menu.copy-readonly-link'
	| 'share-menu.offline-note'
	| 'share-menu.copy-link-note'
	| 'share-menu.copy-readonly-link-note'
	| 'share-menu.project-too-large'
	| 'share-menu.upload-failed'
	| 'status.offline'
	| 'status.online'
	| 'people-menu.title'
	| 'people-menu.change-name'
	| 'people-menu.change-color'
	| 'people-menu.follow'
	| 'people-menu.following'
	| 'people-menu.leading'
	| 'people-menu.user'
	| 'people-menu.invite'
	| 'help-menu.title'
	| 'help-menu.about'
	| 'help-menu.discord'
	| 'help-menu.github'
	| 'help-menu.keyboard-shortcuts'
	| 'help-menu.twitter'
	| 'actions-menu.title'
	| 'edit-link-dialog.title'
	| 'edit-link-dialog.invalid-url'
	| 'edit-link-dialog.detail'
	| 'edit-link-dialog.url'
	| 'edit-link-dialog.clear'
	| 'edit-link-dialog.save'
	| 'edit-link-dialog.cancel'
	| 'embed-dialog.title'
	| 'embed-dialog.back'
	| 'embed-dialog.create'
	| 'embed-dialog.cancel'
	| 'embed-dialog.url'
	| 'embed-dialog.instruction'
	| 'embed-dialog.invalid-url'
	| 'edit-pages-dialog.move-down'
	| 'edit-pages-dialog.move-up'
	| 'shortcuts-dialog.title'
	| 'shortcuts-dialog.edit'
	| 'shortcuts-dialog.file'
	| 'shortcuts-dialog.preferences'
	| 'shortcuts-dialog.tools'
	| 'shortcuts-dialog.transform'
	| 'shortcuts-dialog.view'
	| 'shortcuts-dialog.collaboration'
	| 'home-project-dialog.title'
	| 'home-project-dialog.description'
	| 'rename-project-dialog.title'
	| 'rename-project-dialog.cancel'
	| 'rename-project-dialog.rename'
	| 'home-project-dialog.ok'
	| 'style-panel.title'
	| 'style-panel.align'
	| 'style-panel.vertical-align'
	| 'style-panel.position'
	| 'style-panel.arrowheads'
	| 'style-panel.arrowhead-start'
	| 'style-panel.arrowhead-end'
	| 'style-panel.color'
	| 'style-panel.dash'
	| 'style-panel.fill'
	| 'style-panel.font'
	| 'style-panel.geo'
	| 'style-panel.mixed'
	| 'style-panel.opacity'
	| 'style-panel.size'
	| 'style-panel.spline'
	| 'tool-panel.drawing'
	| 'tool-panel.shapes'
	| 'tool-panel.more'
	| 'debug-panel.more'
	| 'navigation-zone.toggle-minimap'
	| 'navigation-zone.zoom'
	| 'focus-mode.toggle-focus-mode'
	| 'toast.close'
	| 'file-system.file-open-error.title'
	| 'file-system.file-open-error.not-a-tldraw-file'
	| 'file-system.file-open-error.file-format-version-too-new'
	| 'file-system.file-open-error.generic-corrupted-file'
	| 'file-system.confirm-open.title'
	| 'file-system.confirm-open.description'
	| 'file-system.confirm-open.cancel'
	| 'file-system.confirm-open.open'
	| 'file-system.confirm-open.dont-show-again'
	| 'file-system.confirm-clear.title'
	| 'file-system.confirm-clear.description'
	| 'file-system.confirm-clear.cancel'
	| 'file-system.confirm-clear.continue'
	| 'file-system.confirm-clear.dont-show-again'
	| 'file-system.shared-document-file-open-error.title'
	| 'file-system.shared-document-file-open-error.description'
	| 'sharing.confirm-leave.title'
	| 'sharing.confirm-leave.description'
	| 'sharing.confirm-leave.cancel'
	| 'sharing.confirm-leave.leave'
	| 'sharing.confirm-leave.dont-show-again'
	| 'toast.error.export-fail.title'
	| 'toast.error.export-fail.desc'
	| 'toast.error.copy-fail.title'
	| 'toast.error.copy-fail.desc'
	| 'context.pages.new-page'
	| 'vscode.file-open.desc'
	| 'vscode.file-open.open'
	| 'vscode.file-open.backup'
	| 'vscode.file-open.backup-saved'
	| 'vscode.file-open.backup-failed'
	| 'vscode.file-open.dont-show-again'
	| 'cursor-chat.type-to-chat'
